import { getFormattedDate } from "@/utils/Common";
import Link from "next/link";
import React from "react";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";

const MarketInsightCard = ({ data }) => {
  return (
    <>
      <div className="w-[100%]  mb-8  px-2">
        <div className="mt-2 text-[1.5rem] h-[4.2rem] leading-8 hideLongTypography2 font-mukta">
          {data?.title}
        </div>
        <div className="flex mt-2 items-center text-[#4D4D4D] text-[0.78rem] font-medium">
          <p>{getFormattedDate(data?.created_at)}</p>
        </div>

        <p className="text-[#666666] my-3 text-[0.85rem] h-[5.2rem] hideLongTypography4 sm:w-[80%]">
          {data?.description}
        </p>

        <p className="mt-10 text-red text-[0.9rem] sm:text-[1rem] items-baseline cursor-pointer font-mukta font-medium">
          <Link
            href={`/market-insights/${data?.slug}-${data?.id}`}
            className="font-medium"
          >
            Read Now{" "}
            <KeyboardBackspaceIcon className="rotate-180 ml-1 mb-[2px] text-[1.2rem] " />
          </Link>
        </p>
      </div>
    </>
  );
};

export default MarketInsightCard;
